import * as Sentry from "@sentry/react";
import { BrowserRouter } from "react-router-dom";
import { AppProviders } from "./AppProviders";
import { ErrorFallback } from "./components/ErrorFallback";
import { buildErrorReference, getErrorReference } from "./lib/observability";
import { CoachingRoutes } from "./routes/coaching-routes";

export { selectAuthAwareRoutePath } from "./routes/auth-aware-route-path";

function renderRootErrorFallback({ error, eventId }: { error: unknown; eventId: string }) {
  return <ErrorFallback reference={getErrorReference(error) ?? buildErrorReference(eventId)} />;
}

export default function App() {
  return (
    <Sentry.ErrorBoundary
      fallback={renderRootErrorFallback}
      beforeCapture={(scope) => {
        scope.setTag("source", "root-error-boundary");
      }}
    >
      <AppProviders>
        <BrowserRouter>
          <CoachingRoutes />
        </BrowserRouter>
      </AppProviders>
    </Sentry.ErrorBoundary>
  );
}
